export default __webpack_public_path__ + "static/media/thumbnail_blog_16.a61dd0d5.jpg";